export default __webpack_public_path__ + "static/2-8784e7731aea17e652abf48d86efa05c.png";